function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 68.97,
  y1: 137.25,
  x2: 68.97,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ef6e22"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#ef7024"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#f1782a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#f48535"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#f89844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f99e49"
})), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M50.43,62.79a17,17,0,1,1-1.79,24,17,17,0,0,1,1.79-24m20.22-48a61.55,61.55,0,0,1,52.44,62l-7.41-.55a54.11,54.11,0,0,0-45.58-54ZM69.54,29.67a46.71,46.71,0,0,1,38.73,46l-7.43-.56A39.28,39.28,0,0,0,69,37.12l.49-6.58Zm36.37,60.7,7.59.57a54.14,54.14,0,1,1-58.32-69l-.56,7.56a46.71,46.71,0,1,0,51.29,60.87m14-6.58h0l-14.19-1.06h0l-5.45-.4A39.3,39.3,0,1,1,61.79,36.41L62.27,30l.08-1h-.07l.55-7.42h.07l.4-5.33.15-2.07A61.55,61.55,0,1,0,122.54,84ZM71.76,0a76.36,76.36,0,0,1,66.15,77.89l-7.41-.55A69,69,0,0,0,71.2,7.41Z"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.002 0 137.94 137.251",
    width: 137.94,
    height: 137.251,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5f2d4a2d.svg";
export { ForwardRef as ReactComponent };